import styled from 'styled-components/macro';
import { extraSmallScreens, lowHeightScreens, mediumScreens, smallScreens } from '../../../../common/fontElements';
import {
  blue1,
  darkGray1,
  darkGray14,
  gulfBlue,
  lightBlack,
  lightGray1,
  lightGray15,
  lightGray21,
  lightGray7,
  white,
} from '../../../../common/colorConstants';

export const SpinnerWrapper = styled.div`
  width: 100%;
`;

export const TitleText = styled.p`
  font-size: 12px;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0;
  text-align: left;
  margin: 0;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 13px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 12px;
  }

  padding: 0 0 7px 30px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  line-height: 18px;
  color: ${lightBlack};
`;

export const TitleTextLight = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
  color: ${darkGray1};
`;

export const OverallStatsWrapper = styled.div`
  padding: 35px 0 0 0;
`;

export const TitleRow = styled.div`
  display: flex;
  padding: 0 30px 10px 30px;
  justify-content: flex-start;
  align-items: center;
  margin: 0;
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    padding: 8px 15px 8px 30px;
  }
`;

export const Arrow = styled.div`
  display: flex;
  margin: 0 5px;
  width: 10px;
  height: 5px;
  color: ${darkGray1};
`;

export const FieldName = styled.span`
  font-weight: 500;
  font-size: 11px;
  color: ${lightBlack};
  font-family: 'Roboto', sans-serif;
  line-height: 18px;
`;

export const FieldValue = styled.span`
  font-size: 11px;
`;

export const Spreadsheet = styled.div`
  margin: 20px 0 0;
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    margin: 10px 0 0;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  padding: 5px 0 5px 32px;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  background: ${lightGray7};
  color: ${darkGray14};
  border-top: 1px solid ${lightGray21};
  border-bottom: 1px solid ${lightGray21};
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    padding: 15px 40px 8px 55px;
  }
`;

export const ResultsColumnHeader = styled.div`
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  min-width: ${(props) => props.$width || '100%'};
  display: flex;
  align-items: center;
  font-size: 9px;
  padding-right: 30px;
  justify-content: ${(props) => props.$justifyContent || 'initial'};
`;

export const CenterPos = styled.div`
  margin: 0 auto;
`;

export const Row = styled.div`
  display: flex;
  padding: 15px 0 15px 32px;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0;
  border-bottom: 1px solid #d8e8ef;
  background: ${({ open }) => (open ? lightGray7 : white)};
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    padding: 10px 40px 10px 55px;
  }
`;

export const ResultsColumn = styled.div`
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  min-width: ${(props) => props.$width || '100%'};
  display: flex;
  font-size: 11px;
  align-items: flex-start;
  white-space: pre-wrap;
  word-break: break-word;
  text-overflow: ellipsis;
  padding-right: 30px;
  justify-content: ${(props) => props.$justifyContent || 'initial'};
  @media screen and (max-height: ${extraSmallScreens}), screen and (max-width: ${extraSmallScreens}) {
    font-size: 9px;
  }
`;

export const TitleWrapper = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DetailsButton = styled.button`
  border-radius: 3px;
  width: 18px;
  height: 18px;
  background-color: ${white};
  background-repeat: no-repeat;
  background-position: center;
  background-size: 8px;
  background-image: url(${({ open }) => `/images/arrows/down-arrow-${open ? 'blue' : 'gray'}.svg`});
  transform: ${({ open }) => (open ? `rotateX(180deg)` : `rotateX(0)`)};
  border: 1px solid ${({ open }) => (open ? blue1 : lightGray1)};
`;

export const NoData = styled.span`
  color: ${lightGray1};
`;

export const HistoryRow = styled.div`
  background: ${lightGray7};
  border-bottom: 1px solid ${lightGray15};
  padding-bottom: 10px;
`;

export const ItemRow = styled.div`
  display: flex;
  padding: 5px 15px 3px 32px;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0;
`;

export const DetailsItem = styled.div`
  word-break: initial;
`;

export const DetailsItems = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DetailsText = styled(TitleText)`
  padding-left: 5px;
  color: var(--primary-text-and-background-dark, ${gulfBlue});
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 17.766px;
`;
